import type { ReactNode } from 'react';
import { classes } from '@src/components/layout/space';
import { testIdAttr } from '@src/components/testId';
import './RowList.css';

export interface RowListProps {
  children: ReactNode;
  className?: string;
  testId?: string;
}

export function RowList({ children, className, testId }: RowListProps) {
  return (
    <ul className={classes('row-list', className)} {...testIdAttr(testId)}>
      {children}
    </ul>
  );
}

export type RowTone = 'default' | 'catalog';
export type RowSize = 'default' | 'large';

export interface RowProps {
  children?: ReactNode;
  tone?: RowTone;
  /** Large is for a row carrying a face or two lines of text. */
  size?: RowSize;
  align?: 'start' | 'center';
  as?: 'li' | 'div';
  className?: string;
  testId?: string;
  'aria-hidden'?: boolean;
}

export function Row({
  children,
  tone = 'default',
  size = 'default',
  align = 'start',
  as: Tag = 'li',
  className,
  testId,
  'aria-hidden': ariaHidden,
}: RowProps) {
  return (
    <Tag
      className={classes(
        'row',
        tone === 'catalog' && 'row--catalog',
        size === 'large' && 'row--large',
        align === 'center' && 'row--center',
        className,
      )}
      aria-hidden={ariaHidden}
      {...testIdAttr(testId)}
    >
      {children}
    </Tag>
  );
}
